export default __webpack_public_path__ + "static/mariia-978293247cec45714a246ce8a9e94981.webp";